export type Platform = 'electron' | 'capacitor' | 'web';

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform: () => boolean;
      getPlatform: () => string;
    };
  }
}

export function detectPlatform(): Platform {
  if (typeof window !== 'undefined') {
    if (window.electron) return 'electron';
    if (window.Capacitor?.isNativePlatform()) return 'capacitor';
  }
  return 'web';
}

export function isElectron(): boolean {
  return detectPlatform() === 'electron';
}

export function isCapacitor(): boolean {
  return detectPlatform() === 'capacitor';
}

export function isWeb(): boolean {
  return detectPlatform() === 'web';
}

export function isNative(): boolean {
  const p = detectPlatform();
  return p === 'electron' || p === 'capacitor';
}

export const currentPlatform = detectPlatform();
